<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
            d="M2.28655 12.5714H1.71512C1.41201 12.5714 1.12133 12.451 0.907 12.2366C0.692674 12.0223 0.572266 11.7316 0.572266 11.4285V9.14281C0.572266 8.8397 0.692674 8.54901 0.907 8.33468C1.12133 8.12035 1.41201 7.99995 1.71512 7.99995H3.42941L4.30941 5.34852C4.38893 5.11197 4.54369 4.90795 4.75006 4.76762C4.95643 4.62729 5.20304 4.55837 5.45227 4.57138H10.0351C10.2843 4.55837 10.531 4.62729 10.7373 4.76762C10.9437 4.90795 11.0985 5.11197 11.178 5.34852L12.0008 7.99995H14.2866C14.5896 7.99995 14.8804 8.12035 15.0947 8.33468C15.309 8.54901 15.4294 8.8397 15.4294 9.14281V11.4285C15.4294 11.7316 15.309 12.0223 15.0947 12.2366C14.8804 12.451 14.5896 12.5714 14.2866 12.5714H13.7151"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M11.9986 14.2855C11.0512 14.2855 10.2832 13.5175 10.2832 12.57C10.2832 11.6225 11.0512 10.8545 11.9986 10.8545C12.9462 10.8545 13.7142 11.6225 13.7142 12.57C13.7142 13.5175 12.9462 14.2855 11.9986 14.2855Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M3.9987 14.2855C3.05126 14.2855 2.2832 13.5175 2.2832 12.57C2.2832 11.6226 3.05126 10.8545 3.9987 10.8545C4.94614 10.8545 5.7142 11.6226 5.7142 12.57C5.7142 13.5175 4.94614 14.2855 3.9987 14.2855Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M10.2839 12.5713H5.71484"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
